import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import { useEffect } from 'react';

export const Sexo = ({sexo,handleChangeSexo,disabled})=>{

    useEffect(()=>{
        if (!sexo) {
            handleChangeSexo({target:{value:'M'}});
        }
    }, [sexo, handleChangeSexo]);
    
    return <Box sx={{marginTop:'1rem',textAlign:'left',marginBottom:'1rem'}}>
        <FormControl>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={sexo}
                className="flex"
                onChange={handleChangeSexo}>
                    <FormControlLabel value="M" control={<Radio disabled={disabled || false}/>} label="Hombre" />
                    <FormControlLabel value="F" control={<Radio disabled={disabled || false}/>} label="Mujer" />
            </RadioGroup>
        </FormControl>
    </Box>

}